import { useQuery } from '@tanstack/react-query';
import { fetchDeviceDetails } from '../api/deviceDetails';

export const deviceDetailsKeys = {
  all: ['deviceDetails'] as const,
  detail: (deviceId: string) => [...deviceDetailsKeys.all, deviceId] as const,
};

// useDeviceDetails loads the full details for a single device by UUID.
export function useDeviceDetails(deviceId: string) {
  return useQuery({
    queryKey: deviceDetailsKeys.detail(deviceId),
    queryFn: () => fetchDeviceDetails(deviceId),
    enabled: Boolean(deviceId),
    staleTime: 1 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
